import { Property } from "./interfaces";

export const consecutivo: Property = { title: "Consecutivo", type: "integer" }